import React from 'react';
import './Services.css';

// Sprawdzone, działające zdjęcia z Cloudimage
const services = [
    {
        title: "Hybrydy / EV",
        desc: "Diagnostyka baterii, wymiana ogniw, serwis wysokiego napięcia",
        image: "https://i.pinimg.com/736x/d2/29/41/d22941519c43ac2657c53349ad54a1e8.jpg"
    },
    {
        title: "Silniki i skrzynie",
        desc: "Kompleksowa naprawa mechaniczna, wymiana oleju, rozrządy",
        image: "https://i.pinimg.com/1200x/11/d2/8d/11d28d80cd42c1b94a84e41f7421e05c.jpg"
    },
    {
        title: "Autoelektryka",
        desc: "Sterowniki, czujniki, instalacje elektryczne",
        image: "https://i.pinimg.com/736x/4b/fb/3a/4bfb3acff21f5563e00943b502dc84ee.jpg"
    },
    {
        title: "Wulkanizacja",
        desc: "Wycena i wymiana opon, wyważanie kół",
        image: "https://i.pinimg.com/1200x/66/54/6f/66546f752f9a1057f2bd1fb76a7ec04d.jpg"
    },
    {
        title: "Hamulce",
        desc: "Wymiana klocków, tarcz, płynu hamulcowego",
        image: "https://i.pinimg.com/1200x/0c/e4/5c/0ce45cd6b6b697c0ad92d23a12554640.jpg"
    },
    {
        title: "Zawieszenie",
        desc: "Diagnostyka i naprawa układu jezdnego",
        image: "https://i.pinimg.com/1200x/28/ca/a1/28caa1183fc57e55b534e9f7ddf7e50d.jpg"
    }
];

const Services = () => {
    return (
        <section id="services">
            <div className="container">
                <div className="section-title">Nasze usługi</div>
                <div className="section-subtitle">Oferujemy kompleksową obsługę Twojego pojazdu</div>
                <div className="services-grid">
                    {services.map((service, index) => (
                        <div className="service-card" key={index}>
                            <div className="service-image">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    loading="lazy"
                                    style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                />
                                <div className="service-overlay"></div>
                            </div>
                            <div className="service-content">
                                <h3>{service.title}</h3>
                                <p>{service.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;